import { createFileRoute } from "@tanstack/react-router";
import { ExerciseResults } from "@/components/exercise-results";
import { useT } from "@/glossary";

export const Route = createFileRoute("/prod/results")({
  component: ProdResults,
});

function ProdResults() {
  const t = useT();
  return (
    <ExerciseResults
      id="prod"
      nextStep={{
        prompt: t.prod.tuneYourEarPrompt,
        label: t.prod.tuneYourEarLink,
        to: "/train/exercise",
      }}
      againLabel={t.prod.speakAgain}
    />
  );
}
